export default __webpack_public_path__ + "static/media/October2011.fbc3c428.png";